// TODO: (D.K.) Need improve this feature
export const getTransformLeft = ({ transformLeftStep, transformLeftMax, isLastSlide, activeItem, isRightToLeft, }) => {
    const transformLeft = isLastSlide ? transformLeftMax : transformLeftStep * activeItem;
    return isRightToLeft ? transformLeft : -transformLeft;
};
export const getSlides = (itemCarouselWidth, leftMax, getterSize) => {
    let slides = 1;
    let slidesWidth = itemCarouselWidth;
    while (slidesWidth < leftMax) {
        slides += 1;
        slidesWidth = (itemCarouselWidth + getterSize) * slides - getterSize;
    }
    return slides + 1;
};
